import script from "./middleColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./middleColumn.vue?vue&type=script&setup=true&lang=ts"

import "./middleColumn.vue?vue&type=style&index=0&id=b67358b4&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b67358b4"]])

export default __exports__